import styles from "./Footer.module.scss";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footer__content}>
        <p className={styles.footer__text}>
          &copy; 2024 Orhan Door Bütün hüquqlar qorunur. Hazırlayan
          <a href="/" className={styles.site_url}>
            Bionet
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
